import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

export const EditRubricErrorBanner: React.FC<{ error: string }> = ({
  error,
}) => {
  return (
    <div className="flex justify-center items-center py-4 px-3 rounded-xl border-1 border-red-400 bg-red-200 w-[880px]">
      <S2Typography
        variant="body-6-medium"
        textColorVariant="red-800"
        translatedContent={error}
      />
    </div>
  );
};
